import { Field } from "@headlessui/react";
import { KeyIcon } from "@heroicons/react/24/outline";
import { UserRole } from "../../../../app/userSlice";
import ResetPasswordByAdmin from "./ResetPasswordByAdmin";
import { EditUserViewModel } from "../../usersApiSlice";

interface ResetPasswordProps {
	userInfo: EditUserViewModel;
	setSuccessMessage: (message: string) => void;
	setErrorMessage: (message: string) => void;
}

export default function ResetPasswordSetting(props: ResetPasswordProps) {
	return (
		<div className="flex items-center">
			<KeyIcon className="size-16 shrink-0" />
			<div className="ml-6">
				<p>Reset Password:</p>
				<Field className="flex items-center ml-2 mt-1">
					<ResetPasswordByAdmin
						userId={props.userInfo.id}
						isResettingForStudent={props.userInfo.role === UserRole.Writer}
						name={props.userInfo.fullName}
						rules={props.userInfo.rules}
						setSuccessMessage={props.setSuccessMessage}
						setErrorMessage={props.setErrorMessage}
					/>
				</Field>
			</div>
		</div>
	);
}
